<template>

    <SubHeader title="Fiche Institutions" :breads="[ { name: 'Fiche Institution' }]"
        :action="{to:'AdminConfigInstitution',title:'Revernir sur la liste'}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="prepareUpdate">


                <div class="row">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" v-model="institutionShowItems.label" id="label" class="form-control"
                                        placeholder="Institution" value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="email">Email</label>
                                    <input type="text" v-model="institutionShowItems.email" id="email" class="form-control"
                                        placeholder="Email" value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="contact">Contact</label>
                                    <input type="text" v-model="institutionShowItems.phone" id="contact" class="form-control"
                                        placeholder="contact" value="">
                                </div>
                                <div class="mb-3 ">
                                    <label class="form-label" for="type">Type</label>
                                    <m-select v-model="institutionShowItems.institution_type" :loading="institutionTypeIsLoading"  :required="true" :options="institutionTypeItems" :searchable="false" 
                                        placeholder="Type d'institution" track-by="id" label="label" >
                                    </m-select>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Modifier</button>&nbsp;
                                <button type="button" class="btn btn-danger  mx-3">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigShowInstitution",
    components: {
        SubHeader
    },
    data() {
        return {
            dataAccept: ["id","institution_type","label","phone","email"],
        }
    },

    computed: {
        ...mapFields("institution/update", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            isUpdated:"isUpdated"

        }),
        ...mapFields("institution_type/list", {
            institutionTypeIsLoading: "isLoading",
            institutionTypeIsSuccess: "isSuccess",
            institutionTypeShowMessage: "showMessage",
            institutionTypeMessage: "message",
            institutionTypeItems: "items"

        }),
        ...mapFields("institution/show", {
            institutionShowIsLoading: "isLoading",
            institutionShowIsSuccess: "isSuccess",
            institutionShowShowMessage: "showMessage",
            institutionShowMessage: "message",
            institutionShowItems: "item"

        })
    },

    methods: {
        ...mapActions({
            handleSubmit: "institution/update/update",
            reset: "institution/update/resetData",
            getInstitutionTypes: "institution_type/list/getAll",
            getCurrentInstitution:"institution/show/getOne"
        }),
        prepareUpdate(){
            var backData = {}
            this.dataAccept.forEach(it => {
                if("institution_type" == it ){
                    backData["institutiontype_id"]  = this.institutionShowItems[it]?.id ?? null
                    
                } else{
                    backData[it]  = this.institutionShowItems[it]
                }
            });
            this.handleSubmit(backData)

        }
    },
    watch:{
        
        isUpdated(val){
            if(val){
                this.$router.push({name:'AdminConfigInstitution'})
            }
        }
    },

    unmounted() {
        this.reset()
    },
    mounted() {
        
        this.getCurrentInstitution(this.$route.params.id)
        this.getInstitutionTypes()
    }
}
</script>
